import {TFunction} from 'i18next';

export const capitalizeString = (value?: string) => {
  if(!value) return '-';
  const lower = value.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

export const formatNumber = (num: number): string => {

  if(num === null || num === undefined) return '-';

  const isInteger = Number.isInteger(num);

  return num.toLocaleString('es-ES', {
    useGrouping: true,
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: isInteger ? 0 : 2,
  });
};


export const toFormattedDateDDMMYY = (date?: Date): string => {

  if(!date) return '-';

  return  date.toLocaleString('es-ES', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour12: false // para 24h
  });

};

export const enumToOptions = (enumObj: Record<string, string>, t: TFunction, translationContext: string) =>
  Object.values(enumObj).map(value => ({
    id: value,
    label: t(`${translationContext}.${value.toLowerCase()}`)
  }));